import { lightTheme } from '@rodeo-dev/legos'
import styled from 'styled-components'

const { palette } = lightTheme

const DialogPdfPreviewHeader = styled.header`
  background-color: ${palette.primary.main};
  display: block;
  padding: 32px 70px 30px;
  text-align: left;
  width: 100%;

  h2 {
    font-weight: normal;
    font-family: LeagueGothicRegular, georgia, times, serif;
    font-size: 55px;
    line-height: 50px;
    color: ${palette.primary.contrastText};
    text-transform: uppercase;
    margin: 0;
  }
`

export default DialogPdfPreviewHeader
